<template>
  <div class="AlternativesTableComponent DataTables">
  
    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'
import IconSvg from '@/components/shared/IconSvg'

export default {
  name: 'AlternativesTableComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent,
    IconSvg,
  },
  data () {
      return {
        name: 'AlternativesTableComponent',
        mainTable: "",
        id: 'AlternativesTableComponent' + String(this._uid),
        columns: [],
        colsAssign: [],
        alternatives: [],
        isData: false,
        endoflife: null,
        endofsale: null,
        completeInit: false,
        temp: 9
      }
  },
  computed: {
    ...mapGetters({

      globalSettings: "globalSettings",
      globalSettings: "globalSettings",
      currentUser: 'currentUser'
    }),
    partId(){

      if (this.parent == "bom"){
        return this.$store.getters.selectedPartBomRow.partId;
      }
      let partId = "";
          
      if (this.$store.getters.selectedRows.length != 0){
        partId = this.$store.getters.selectedRows[0].col___revisionId.partId;
        
        
      }
      return partId;
      
   
    },
    revisionId() {

      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.revisionId;
      }

      let revisionId = "";

      if (this.$store.getters.selectedRows.length != 0) {
        revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;


      }
      return revisionId;


    },
    isAssembly() {
      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.assembly;
      }
      if (this.$store.getters.selectedRows.length != 0) {
        return this.$store.getters.selectedRows[0].col___status.assembly;
      }
      return false;
    },
    reloadedAfterAction() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {

    
    this.createTable(); 


  },
  watch: {
    partId: {
      handler: function(newVal, oldVal){
        
        this.createTable();
      },
      deep: true
    
      
    },
    
    
    reloadedAfterAction: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {
              
              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    setSEOverall(distributorPartId, data) {

      let _vue = this;

      

      let field = document.getElementById(this.parent +"_id_" + distributorPartId);
      
      if (field == null) {
        return;
      }
      if (data == null) {
        let str1 = "<button class=\"btn btn-secondary btn-sm btn-" + this.variant + " button_action_overallSE\">OverallRisk: ";
        let str2 = "<b-badge class='badge badge-primary'>No data</b-badge> ";
        let str3 = "</button >";
        field.innerHTML = str1 + str2 + str3;
        return;
      }

      let index = data.OverallRisk.indexOf("%");
      if (index > -1) {
        let temp = data.OverallRisk.split("%");
        let str1 = "<button class=\"btn btn-secondary btn-sm btn-" + this.variant + " button_action_overallSE\">OverallRisk";
        let str2 = "";
        let str3 = "</button >";
        if (temp[0] < 25) {
          str2 = "<b-badge class='badge badge-success'>Low</b-badge> ";
        }else if (temp[0] > 50) {
          str2 = "<b-badge class='badge badge-danger'>High</b-badge> ";
        } else if (!(temp < 25) && !(temp > 50)) {
          
          str2 = "<b-badge class='badge badge-warning'>Middle</b-badge> ";
          
        }
        field.innerHTML = str1 + str2 + str3;
       
        


        field.children[0].addEventListener("click", function () {


          // var tr = $(this).closest('tr');
          // var row = _vue.mainTable.row(tr);

          // var data = row.data();


          

          var obj = {

            text: "",
            type: "SERisk",
            buttons: 1,
            buttonName: "Close",
            size: "xl",
            data: data,
            lang: _vue.lang.modal_SERisk,
            funcNo: "",
            funcYes: "",
            funcCustom: ""
          };
          _vue.$store.dispatch("showModalComponent", obj);



        }, false)
        
      }

      
    },
    startSEDetails() {
      for (let i = 0, lei = this.alternatives.length; i < lei; i++){
        const obj = {
          distributorPartId: this.alternatives[i].DistributorPartId,
          manufacturerPartNumber: this.alternatives[i].ManufacturerPartNumber,
          manufacturerName: this.alternatives[i].ManufacturerName
        }

        

        this.getSEDetails(obj);
      }
    },
    getSEDetails(obj) {
      let vue = this;

      
      this.$store.dispatch("pm_getSEDetailsByMPN", obj)
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {
            vue.setSEOverall(obj.distributorPartId, result.data);


            
          } else {
            vue.setSEOverall(obj.distributorPartId, result.data);
          }

        })
    },
    createTable() {
      
      let vue = this;

      const obj = {};
      let action = "";

      if (this.isAssembly == true) {
        action = "_getPhysicalsAssembly";
        obj.partRevisionId = this.revisionId;
      }else {
        action = "_getPhysicals";
        obj.partId = this.partId;
      }
        

      this.$store.dispatch(this.$store.getters.sectionPrefix + action, obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.alternatives = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    format ( d ) {
    // `d` is the original data object for the row
      let disabled1 = "";
      let disabled2 = "";
      if (d.ByUser == true){
        disabled1 = "disabled";
      }
      if (this.currentUser.role == 'Reader') {
        disabled2 = "disabled";
      }

        
      let date1 = new Date(d.syncDate);
      let date2 = new Date();
      
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    

      let obsolete = "";
      if (diffDays > 7) {
        obsolete = "obsolete";
      }
      let syncDate = '<td>' + this.lang.table_header_Manual + ':</td>' +
        '<td><span >' + this.lang.table_info_Manual + '</span></td>' +
        '</tr>';
      if (d.ByUser == false) {
        syncDate = '<tr>' +
          '<td>' + this.lang.table_header_SyncDate + ':</td>' +
          '<td><span class=\"' + obsolete + '\">' + Tools.longDateToShort(d.syncDate) + '</span></td>' +
          '</tr>';
      } 
      let pos = -1;
      let link = d.Datasheet;
      let toDisplay = d.Datasheet;
      if (this.globalSettings.displayHttpLinks == true) {

        pos = toDisplay.indexOf("http");

        if (pos > -1) {
          toDisplay = "<a href='" + link + "' target='_blank'>Link</a>";
        }
      }
      if (this.globalSettings.displayLocalLinks == true) {
        pos = toDisplay.indexOf("\\\\");
        if (pos > -1) {

          link = toDisplay.split('\\').join('/');

          link = "file:///" + link
          toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
        }
        pos = link.indexOf("file://");
        if (pos > -1) {

          toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
        }
      }
      let a = d.ManufacturerPartNumber + "__" + d.ManufacturerName;
      
      return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%;">'+
                '<tr>'+
                    '<td>'+this.lang.table_header_Description+':</td>'+
                    '<td>'+d.Description+'</td>'+
                '</tr>' +
                '<tr>' +
                    '<td>' + this.lang.table_header_Datasheet + ':</td>' +
                    '<td>' + toDisplay + '</td>' +
                '</tr>' +
                '<tr>'+
                    '<td>'+this.lang.table_header_Login+':</td>'+
                    '<td>'+d.LoginAssign+'</td>'+
                '</tr>'+
                '<tr>'+
                    '<td>'+this.lang.table_header_Date+':</td>'+
                    '<td>'+Tools.longDateToShort(d.DateAssign)+'</td>'+
                '</tr>'+
                syncDate +
                '<tr>'+
                    '<td>Action:</td>'+
                    '<td><button  ' + disabled2 + ' class=\"btn btn-sm btn-'+this.variant+' button-action-unassign\" id=\"button_unassign__'+ d.DistributorPartId + '">'+this.lang.table_button_Unassign+'</button><button  class=\"btn btn-sm  btn-'+this.variant+' button-action-unassign\" id=\"button_details__'+ d.DistributorPartId + '" data-obj=\"'+a+'\">'+this.lang.table_button_Details+'</button><button  ' + disabled1 + ' '+ disabled2 +' class=\"btn btn-sm  btn-'+this.variant+' button-action-sync\" id=\"button_sync__'+ d.DistributorPartId + '"><span class="spinner-border spinner-border-sm spiner-sync"></span> <span class="button-text">'+this.lang.table_button_Sync+'</span></button></td>'+
                '</tr>'+
            '</table>';
    },
    buildColumns(){

      this.columns = [
        {
          name: this.lang.table_header_Expand,
          alignInColumn: "left",
          type: "text",
          width: 50
        }, 
        {
          name: this.lang.table_header_Image,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_ManufacturerName,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_ManufacturerPartNumber,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Datasheet,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Login,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Date,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_SyncDate,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Action,
          alignInColumn: "left",
          type: "text"
        },
        
        
      ]

      this.colsAssign =  [
        
        {
            "className": 'details-control',
            "orderable": false,
            "data": null,
            "defaultContent": '<img src="/static/plus.svg">'
        },
        { "data": "imageUrl" },
        { "data": "DistributorPartId" },
        { "data": "ManufacturerName" },
        { "data": "ManufacturerPartNumber" },
        { "data": "Description" },
        { "data": "Datasheet" },
        { "data": "LoginAssign"},
        { "data": "DateAssign"},
        { "data": "syncDate"},
        { "data": "DistributorPartId" },
               
      ]

      this.buildTable();
    },
    buildTable(){
      this.completeInit = false;

      var tableplace = document.getElementById(this.id);
          
          if (tableplace == null){
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "headerCell");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function (data, type, row, meta) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }
                if (meta.col == 1){
                  if ((data != null) && (data != "") && ((data.indexOf("http://") != -1) || (data.indexOf("https://") != -1))){

                    return "<img class=\"image\" height='40px' src='"+data+"'>";
                  }
                  return "<img class=\"imageSVG\" height='40px' src='/static/part.png'>";   
                }
                if (meta.col == 2) {
                  let endOfPartAlert = "";
                  if(row.endOfPartAlert){
                    endOfPartAlert = "<b-badge class='badge badge-danger '>" + _vue.lang.alert_EndOfPart + "</b-badge> ";
                  }
                  let id = _vue.parent + "_id_" + row.DistributorPartId;
                  
                    let overall = "<span id=" + id + "><button class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button_action_overallSE\">OverallRisk<b-badge class='badge badge-primary ' ><span class=\"spinner-border spinner-border-sm text-"+ _vue.variant+"\" ></span></b-badge ></button></span>";
                    if (_vue.globalSettings.SEDetails == false) {
                      overall = "";
                    }
                    
                  return endOfPartAlert + overall;   
                }
                
                if (meta.col == 6){
                    return Tools.longDateToShort(data);
                }

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            
            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

      }

      var _vue = this;


          var option = {};
          option.paging = false;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.alternatives;
          option.myColumnFormats = this.columns;
          option.select = false;
          option.order = [[2, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {
            
            if (_vue.completeInit == false) {
              _vue.completeInit = true;

              if (_vue.globalSettings.SEDetails == true) {
                _vue.startSEDetails();
              }
              
              
            }
            
            

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          //this.mainTable.column( 1 ).visible( false );
          
          this.mainTable.column( 5 ).visible( false );
          this.mainTable.column( 6 ).visible( false );
          this.mainTable.column( 7 ).visible( false );
          this.mainTable.column( 8 ).visible( false );
          this.mainTable.column(9).visible(false);
          this.mainTable.column(10).visible(false);
          
          


          let _mainTable = this.mainTable;

          this.mainTable
            .on( 'select', function ( e, dt, type, indexes ) {

              var rowData = _mainTable.rows( indexes ).data();
              

              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", rowData[0])

            })
            .on( 'deselect', function ( e, dt, type, indexes ) {
              
              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
            })

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          $('#t_'+this.id +' tbody').on('click', 'td.details-control', function (e) {
            
            
            var tr = $(this).closest('tr');
            var row = _mainTable.row( tr );
    
            if ( row.child.isShown() ) {
                // This row is already open - close it
                e.target.src = "/static/plus.svg";
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                e.target.src = "/static/minus.svg";
                row.child( _vue.format(row.data()) ).show();
                tr.addClass('shown');
            }
          } );

          $("#t_"+this.id + ' tbody').on( 'click', 'button', function (e) {
            
            
            
            let temp = this.id.split("__")

            
            
            if (temp[0] == "button_unassign"){

                let alert_success_unassignAlternative = _vue.lang.alert_success_unassignAlternative;
                let alert_error_unassignAlternative = _vue.lang.alert_error_unassignAlternative;

                let partId = "";
                if (_vue.parent == "bom"){
                  partId = _vue.$store.getters.selectedPartBomRow.partId;
                }else{
                  partId = _vue.$store.getters.selectedRows[0].col___revisionId.partId;
                }

                let unassignParts = function(_vue){
                    let obj = {
                        partId: partId,
                        alternatives: [{
                            distributorPartId: temp[1]
                        }]
                    }
                   
                    _vue.$store.dispatch("unassignPhysicals", obj)
                    .then((result) => {

                        console.log(result)
                        if (result.status == "OK"){
                        //alert
                            if (result.data == 1){

                                _vue.$store.dispatch("unselectAlternative");
                                const reloadObj = {
                                    status: true,
                                    name: "AlternativesTableComponent"
                                }
                                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                                

                                const obj = {
                                  text: alert_success_unassignAlternative,
                                  time: 5,
                                  type: "success"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }else{
                                const obj = {
                                  text: alert_error_unassignAlternative,
                                  time: 15,
                                  type: "danger"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }


                        }
                    })
                    

                }
                        
                const obj = {
                    title: _vue.lang.alert_Title,
                    text: _vue.lang.alert_Text,
                    type: "withdraw",
                    buttons: 2,
                    size: "sm",
                    funcYes: unassignParts,
                    funcNo: "",

                }
            
                _vue.$store.dispatch("showAlert", obj);
                
                
            }
            if (temp[0] == "button_details") {

              let mn = $(this).attr("data-obj");

              let temp2 = mn.split("__");

                let obj = {
                  distributorPartId: temp[1],
                  manufacturerPartNumber: temp2[0],
                  manufacturerName: temp2[1],  
                }
                
                _vue.$store.dispatch("selectAlternative", obj)

                
            }
            if (temp[0] == "button_sync"){

              //let button_text =  document.getElementsByClassName("button-text");
              let button_action_sync = document.getElementsByClassName("button-action-sync");

              
              let spinner_button = document.getElementsByClassName("spiner-sync");
              let spinner = null;
              if (spinner_button != null) {
                for (let i = 0, lei = button_action_sync.length; i < lei; i++){
                  
                  let sp = button_action_sync[i].id.split("__");
                  
                  if (sp[1] == temp[1]) {
                    button_action_sync[i].style.width = "60px";
                    button_action_sync[i].children[0].style.display = "block";
                    button_action_sync[i].children[0].style.float = "left";
                    spinner = button_action_sync[i];
                //button_text[0].style.display = "none";
                  }
                }
                
              }

              let alert_success_syncAlternative = _vue.lang.alert_success_syncAlternative;
              let alert_error_syncAlternative = _vue.lang.alert_error_syncAlternative;

              let obj = {
                  distributorPartId: temp[1]
              }
              
              _vue.$store.dispatch("pm_syncDistributorPart", obj)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){
              
                  if (result.data == 1){

                      
                      const reloadObj = {
                          status: true,
                          name: "AlternativesTableComponent"
                      }
                      _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                      

                      const obj = {
                      text: alert_success_syncAlternative,
                      time: 5,
                      type: "success"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);
                  }else{
                      const obj = {
                      text: alert_error_syncAlternative + ".",
                      time: 15,
                      type: "danger"
                      }

                    _vue.$store.dispatch("displayFooterAlert", obj);

                    spinner.style.width = "33px";
                    spinner.children[0].style.display = "none";
                    spinner.children[0].style.float = "left";
                  }


                }else{
                  const obj = {
                    text: alert_error_syncAlternative + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                  spinner.style.width = "33px";
                  spinner.children[0].style.display = "none";
                  spinner.children[0].style.float = "left";
                }
              })

                
            }
            // if (this.checked == true){
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addAlternativePart", obj)
              
            // }else{
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteAlternativePart", obj)
              
            // }
            

            

          })

          
        },


  }
}
</script>


<style lang="scss">


  @import "./../../scss/_custom.scss";

  .AlternativesTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 2px;
    }
    td.details-control {
      //background: url("/static/plus.svg") no-repeat center center;
      img{
        max-width: 30px;
        padding: 2px;  
      }
      
    }
    tr.shown td.details-control {
      img{
        max-width: 30px;
        padding: 2px;  
      }
      //background: url("/static/minus.svg") no-repeat center center;
    }
    .button-action-unassign{
        margin: 2px;
    }
    .button-action-sync{
        margin: 2px;
    }
    .spiner-sync{
      display: none;
    }
    .obsolete{
      color: $orange;
    }
    .badge{
      margin: 2px;
    }
    .button_action_overallSE{
      margin-top: 3px;
      margin-bottom: 3px;
      white-space: nowrap;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AlternativesTableComponent.vue